<template>
  <div class="container-fluid">

    <div class="login">
      <div class="card text-center p-sm-5 p-3" style="width: 750px;">
        <h5 class="card-title">
          <img src="/assets/logo/logo_white.svg" alt="" />
        </h5>

        <div class="card-body">
          <h2>Users</h2>
          <a :href="api_url+'/demo/servicestest/users/dailyActivity'" target="_blank" class="btn btn-dark mt-3">dailyActivity</a>
          <a :href="api_url+'/demo/servicestest/users/sentMandatesEmails'" target="_blank" class="btn btn-dark mt-3">sentMandatesEmails</a>
          <h2 class="mt-5">Event</h2>
          <a :href="api_url+'/demo/servicestest/event/updateAttendees'" target="_blank" class="btn btn-dark mt-3">updateAttendees</a>
          <a :href="api_url+'/demo/servicestest/event/sentAbsenseLinksEventsToday'" target="_blank" class="btn btn-dark mt-3">sentAbsenseLinksEventsToday</a>
          <a :href="api_url+'/demo/servicestest/event/sentAbsenseLinksPastEvents'" target="_blank" class="btn btn-dark mt-3">sentAbsenseLinksPastEvents</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import axios from 'axios'
// import loader from "../helper/loader";
// import { mapActions, mapState } from "vuex";
// import Notifications from "../helper/notifications";

export default {
  name: "demo",
  data() {
    return {
      demo_env: process.env.VUE_APP_DEMO_ENV,
      api_url: process.env.VUE_APP_API_BASE_URL,
    };
  },
  methods:{
     test_env: function() {
      if(this.demo_env == 0){
        this.$router.push('login')
      }
     }
 },
  beforeMount(){
    this.test_env();
  },
};
</script>

<style scoped>
.swal2-actions {
  width: 100% !important;
  justify-content: space-between !important;
}
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}

.login {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
  font-size: 15px !important;
}

.text-white {
  font-size: 15px !important;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 15%;
  padding-right: 15%;
  font-size: 18px !important;
}
</style>
